/* tslint:disable */
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { NotificationPreferencesModel } from '../../models/notification-preferences-model';

export interface NotificationPreferencesPutParams {
  body: NotificationPreferencesModel;
}

export function notificationPreferencesPut(
  http: HttpClient,
  rootUrl: string,
  params: NotificationPreferencesPutParams,
  headers: HttpHeaders,
  context?: HttpContext,
): Observable<StrictHttpResponse<NotificationPreferencesModel>> {
  const rb = new RequestBuilder(
    rootUrl,
    notificationPreferencesPut.PATH,
    'put',
  );

  for (const headerKey of headers.keys()) {
    rb.header(headerKey, headers.get(headerKey));
  }

  rb.body(params.body, 'application/json');

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter(
        (r: unknown): r is HttpResponse<unknown> => r instanceof HttpResponse,
      ),
      map((r: HttpResponse<unknown>) => {
        return r as StrictHttpResponse<NotificationPreferencesModel>;
      }),
    );
}

notificationPreferencesPut.PATH = '/api/v1/notifications/preferences';
